import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

import type { Note, SingleUserNoteResponse } from "./types";

type StoredToken = {
  AccessToken?: string;
};

export type CreateUserNotePayload = {
  user_id: string;
  body: string;
};

const createUserNote = async ({
  user_id,
  body,
}: CreateUserNotePayload): Promise<Note | null> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.CREATE_USER_NOTE.replace("{user_id}", user_id),
    { body },
  );

  const responseBody = response?.data as
    | Partial<SingleUserNoteResponse>
    | undefined;

  return (responseBody?.data as Note | undefined) ?? null;
};

export const useCreateUserNote = () =>
  useMutation<Note | null, Error, CreateUserNotePayload>({
    mutationKey: ["createUserNote"],
    mutationFn: createUserNote,
  });
